import { useCallback, useState, useMemo } from 'react';
import { getMaskValueAtPointFunc } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const useMaskedImage = () => {
  const [imageUrlWithoutBackground, setImageUrlWithoutBackground] = useState(null);
  const [imageUrlWithGeneratedBackground, setImageUrlWithGeneratedBackground] = useState(null);
  const [imageUrlWithColoredBackground, setImageUrlWithColoredBackground] = useState(null);
  const [segmentationMasks, setSegmentationMaskInternal] = useState(null);
  const [selectedMasks, setSelectedMasks] = useState([]);
  const [selectedImageSrc, setSelectedImageSrc] = useState(null);
  const [maskSetsBase64, setMaskSetsBase64] = useState(null);
  const [alphaArray, setAlphaArray] = useState([]);

  // mask is encoded in base64 format, decode it here
  const setSegmentationMasks = useCallback(({ maskSetsArray, selectedMasksArray, newAlphaArray }) => {
    setSegmentationMaskInternal(maskSetsArray);
    setSelectedMasks(selectedMasksArray);
    setAlphaArray(newAlphaArray);
  }, []);

  const resetStates = useCallback(() => {
    setImageUrlWithoutBackground(null);
    setSegmentationMaskInternal(null);
    setSelectedMasks([]);
    setSelectedImageSrc(null);
    setMaskSetsBase64(null);
  }, []);

  const maskValues = useMemo(() => Array.from(new Set(segmentationMasks)).filter(x => x > 0), [segmentationMasks]);

  const getMaskValueAtPoint = useCallback((x, y, originalImageWidth) =>
    getMaskValueAtPointFunc(x, y, originalImageWidth, segmentationMasks), [segmentationMasks]);

  return {
    imageUrlWithoutBackground,
    setImageUrlWithoutBackground,
    imageUrlWithGeneratedBackground,
    setImageUrlWithGeneratedBackground,
    imageUrlWithColoredBackground,
    setImageUrlWithColoredBackground,

    // mask
    alphaArray,
    segmentationMasks,
    setSegmentationMasks,
    getMaskValueAtPoint,
    selectedMasks,
    setSelectedMasks,
    selectedImageSrc,
    setSelectedImageSrc,
    maskSetsBase64,
    maskValues,
    setMaskSetsBase64,
    resetStates,
  };
};
